import { TaskID, ProjID } from "./constants";
import { EventBus } from "@xbs/lib-state";
import ActionQueue from "./ActionQueue";
export default class RestDataProvider extends EventBus {
    constructor(url, api) {
        super();
        this._url = url;
        this._api = api;
        this._queue = new ActionQueue();
        const defaultHandlers = {
            "add-task": {
                ignoreID: true,
                kind: TaskID,
                handler: (ev) => this.send("tasks", "POST", ev),
            },
            "update-task": {
                handler: (ev) => {
                    ev.task.batch = this.toArray(ev?.batch);
                    return this.send(`tasks/${ev.id}`, "PUT", ev.task);
                },
            },
            "delete-task": {
                handler: (ev) => {
                    if (ev?.batch) {
                        return this.send(`tasks`, "DELETE", {
                            batch: ev.batch,
                        });
                    }
                    return this.send(`tasks/${ev.id}`, "DELETE");
                },
            },
            "add-project": {
                kind: ProjID,
                ignoreID: true,
                handler: (ev) => this.send(`projects`, "POST", ev.project),
            },
            "update-project": {
                handler: (ev) => this.send(`projects/${ev.id}`, "PUT", ev.project),
            },
            "delete-project": {
                handler: (ev) => this.send(`projects/${ev.id}`, "DELETE"),
            },
            "set-project": {
                handler: (ev) => {
                    let param = "";
                    if (ev.id === null) {
                        param = `?timeout=true`;
                    }
                    return this.send(`tasks/projects/${ev.id}${param}`, "GET").then((data) => {
                        const clientID = this._api.getState().activeProject;
                        if (clientID !== ev.id) {
                            data.forEach(task => {
                                task.project = clientID;
                            });
                        }
                        this._api.parse({
                            tasks: data,
                        });
                        return Promise.resolve();
                    });
                },
            },
            "move-task": {
                debounce: 300,
                handler: (ev) => {
                    return this.send(`move/${ev.id}`, "PUT", {
                        ...ev,
                        id: ev.batch ? 0 : ev.id,
                    });
                },
            },
            "clone-task": {
                skipCorrect: ["batch"],
                handler: (ev) => {
                    return this.send(`clone`, "POST", ev).then(data => {
                        const ids = data;
                        for (let i = 0; i < ev.batch.length; i++) {
                            const clientId = ev.batch[i].id;
                            const serverId = ids[i];
                            this._queue.setID(clientId, serverId, TaskID);
                        }
                    });
                },
            },
            "set-sort": {
                handler: (ev) => {
                    const project = this._api.getState().activeProject;
                    return this.send(`sort/${project}`, "PUT", ev);
                },
            },
        };
        const handlers = this.getHandlers(defaultHandlers);
        for (const x in handlers) {
            this.on(x, (ev) => {
                if (!ev.skipProvider) {
                    this._queue.add(x, ev, handlers[x]);
                }
            });
        }
    }
    getTasks() {
        return this.send("tasks", "GET");
    }
    getProjectTasks(id) {
        return this.send("tasks/projects/" + id, "GET");
    }
    getUsers() {
        return this.send("users", "GET");
    }
    getProjects() {
        return this.send("projects", "GET");
    }
    getTags() {
        return this.send("tags", "GET");
    }
    setAPI(api) {
        this._api = api;
    }
    setHeaders(headers) {
        this._customHeaders = headers;
    }
    getIDResolver() {
        return this._queue.resolve.bind(this._queue);
    }
    getHandlers(handlers) {
        return handlers;
    }
    send(url, method, data, customHeaders = {}) {
        const headers = {
            "Content-Type": "application/json",
            ...customHeaders,
            ...this._customHeaders,
        };
        const req = {
            method,
            headers,
        };
        if (data) {
            req.body = typeof data === "object" ? JSON.stringify(data) : data;
        }
        return fetch(`${this._url}/${url}`, req).then(async (res) => {
            if (res.status == 500) {
                const text = await res.text();
                return Promise.reject(text);
            }
            return await res.json();
        });
    }
    toArray(data) {
        if (!data)
            return [];
        if (Array.isArray(data)) {
            return data;
        }
        return Object.values(data);
    }
}
//# sourceMappingURL=RestDataProvider.js.map